import TemplateView from '../../../../TemplateView'

export default class LoadingSpinnerWrapper extends TemplateView {
    constructor(loadingSpinner) {
        super()
        this.loadingSpinner = loadingSpinner
    }

    templateHtml() {
        return '<div class="loadingSpinnerWrapper"></div>'
    }

    afterRender() {
        this.loadingSpinner.init(this.$el)
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/hierarchyAssignmentsEditor/LoadingSpinnerWrapper.js